module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.30799ef.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Regular.eot
// module id = 198
// module chunks = 1